module.exports = __webpack_public_path__ + "img/9788958280361.efc6472f.jpg";